import { CookieConsentConfig } from "./types";

const APPLICATION_ID = "939C629A-7684-49E0-8C10-3BECBD52E03B";

const POLICY_URL = "/cookie-policy";

/**
 * Consent policy version — increment when the cookie policy changes
 * to invalidate existing consent and re-prompt users for approval.
 */
const POLICY_VERSION = "2025-06";

export const COOKIE_SDK_URLS = {
  production:
    "https://cookie.access-evo.com/consent/access-cookie-policies-js/",
  testing:
    "https://cookie.dev.access-evo.com/consent/access-cookie-policies-js/"
} as const;

export const cookieConsentConfig: CookieConsentConfig = {
  policies: ["essential", "analytics", "functional"],
  parties: [
    {
      policy: "analytics",
      vendors: [
        {
          name: "Coralogix",
          key: "CRX",
          description:
            "Application monitoring and error tracking to maintain service reliability",
          vendorUrl: "https://coralogix.com/privacy-policy",
          partyType: "Third Party"
        },
        {
          name: "Microsoft Clarity",
          key: "MSC",
          description:
            "Session replay and heatmaps to improve the user experience",
          vendorUrl: "https://privacy.microsoft.com/en-gb/privacystatement",
          partyType: "Third Party"
        },
        {
          name: "Google Analytics",
          key: "GA",
          description:
            "Web analytics to understand how visitors use the application",
          vendorUrl: "https://policies.google.com/privacy",
          partyType: "Third Party"
        }
      ]
    },
    {
      policy: "functional",
      vendors: [
        {
          name: "Intercom",
          key: "IC",
          description: "In-app customer support and help widget",
          vendorUrl: "https://www.intercom.com/legal/privacy",
          partyType: "Third Party"
        }
      ]
    }
  ],
  applicationId: APPLICATION_ID,
  policyVersion: POLICY_VERSION,
  policyUrl: POLICY_URL
};
